var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"el-row-resizer",on:{"mousedown":_vm.mousedown}})
}
var staticRenderFns = []

export { render, staticRenderFns }